import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Iframe.module.scss";
export const Iframe = ({ url, className, title, allowFullScreen = true, sandbox = "allow-scripts allow-forms allow-same-origin", ...restProps }) => {
    return (_jsx("div", { className: `${styles.iframe} ${className ? className : ""}`, children: _jsx("iframe", { src: url, title: title, allowFullScreen: allowFullScreen, sandbox: sandbox, ...restProps }) }));
};
//# sourceMappingURL=Iframe.js.map